import { render, staticRenderFns } from "./m-lightbox-template-gallery.vue?vue&type=template&id=5d306061&scoped=true&"
import script from "./m-lightbox-template-gallery.vue?vue&type=script&lang=js&"
export * from "./m-lightbox-template-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d306061",
  null
  
)

export default component.exports